import Debug from 'debug';
import { ExamStateMachineAbstractState, ExamStateMachineCommonEvents } from './state'
import { ExamStateMachineData } from '../data'

const debug = Debug('exam-error-state')

interface Events extends ExamStateMachineCommonEvents {
  onReset: () => void
}

export class ExamErrorState extends ExamStateMachineAbstractState<Events> {

  public readonly name = 'error'

  constructor(private state: ExamStateMachineData,
              private error: unknown) {
    super()
  }

  enter() {
    debug('enter')
    this.state.setCurrentError(this.error)
  }

  exit() {
    debug('exit')
  }

  reset() {
    debug('reset')
    this.triggerEvent(events => events.onReset())
  }

  cancel() {
    debug('cancel')
    this.beginCancel()
    this.endCancel()
  }
}
